import { reactive, computed ,watch, onMounted} from 'vue';
export default {
  components: {},
  props: {
    disable: {
      type: Boolean,
      default: false,
    },
    text: {  // placeholder
      type: String,
      default: ''
    },
    icon: {  // placeholder
      type: String,
      default: ''
    },
    popup_x: {  // placeholder
      type: String,
      default: '0'
    },
    popup_y: {  // placeholder
      type: String,
      default: '0'
    },
    data_up: {  // placeholder
      type: Array,
      default: []
    },
    data_down: {  // placeholder
      type: Array,
      default: []
    },
    theme: {
      type: String,
      default: '1',   // 1: default, 2: has check style
    },
    selected: {
      type: String,
      default: '', //selected value
    },
    active: {
      type: Number,
      default: -1, //selected index =
    }
  },
  setup(props, { emit }) {//emit 傳到複層_emit('update:{function}', val)
    const { icon, disable, theme, selected, active } = props;
    //data
    let state = reactive({
      isOpen: false,
      activeTopIndex: -1,
      activeDownIndex: -1,
      disable: false,
    })

    onMounted(()=>{
      state.disable = disable
    })

    watch(
      () => props.disable,
      (val) => {
        state.disable = val

      })

    const iconSrc = computed(() => {
      if (icon === '') return '';
      return icon.indexOf('http') > -1 ? icon : require(`@/assets/images/${icon}`)
    })

    const classStyle = computed(() => {
      return [
        `theme--${theme}`
      ]
    });

    const privateSelected = computed({
      get: () => selected,
      set: (value) => {
        emit('update:selected', value);
      }
    })

    const privateActive = computed({
      get: () => active,
      set: (value) => {
        emit('update:active', value);
      }

    })
    const onClick = (e, index) => {
      if (theme === '2' || theme === '4') {
        privateActive.value = index;
        state.isOpen = false;
      } //end: theme 2
      emit('onClick', e);
      emit('onClickIndex', index);
    }
    //mounted
    const handleFocusOn = () => {
      if (!state.disable) {
        state.isOpen = !state.isOpen;
      }
      emit('handleFocusOn');
    }
    const handleFocusOut = () => {
      state.isOpen = false
    }






    return {
      state,
      iconSrc,
      onClick,
      handleFocusOn,
      handleFocusOut,
      classStyle,
      privateSelected,
      privateActive
    }
  }
}


